import("flatpickr/dist/flatpickr.css");
import Flatpickr from "stimulus-flatpickr";
Stimulus.register("flatpickr", Flatpickr);
